// extracted by mini-css-extract-plugin
module.exports = {"icon":"sorter__styles__icon--TvbzYvRN","muted":"sorter__styles__muted--1asPsb2T","button":"sorter__styles__button--1GmqCCes","isActive":"sorter__styles__isActive--3eRxrFZC"};